import { render } from "./HeaderSidebarNew.vue?vue&type=template&id=61df15ac&scoped=true"
import script from "./HeaderSidebarNew.vue?vue&type=script&lang=js"
export * from "./HeaderSidebarNew.vue?vue&type=script&lang=js"

import "./HeaderSidebarNew.vue?vue&type=style&index=0&id=61df15ac&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2014718928/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61df15ac"]])

export default __exports__